import { GetArticleBySlug_getArticleBySlug_faq } from 'api/articles/types/GetArticleBySlug';
import styles from './ArticleFaq.module.scss';

type ArticleFaqProps = {
  items: GetArticleBySlug_getArticleBySlug_faq[];
};

// Native details/summary keeps every answer in the HTML, even while collapsed.
const ArticleFaq = ({ items }: ArticleFaqProps): JSX.Element | null => {
  const faq = items.filter(
    (item) => item.question.trim() && item.answer.trim()
  );

  if (!faq.length) {
    return null;
  }

  return (
    <section className={styles.root} aria-labelledby="article-faq">
      <h2 id="article-faq" className={styles.title}>
        Questions from the interview
      </h2>
      {faq.map(({ question, answer }, index) => (
        <details key={`${index}-${question}`} className={styles.item}>
          <summary className={styles.question}>
            <h3 className={styles.questionText}>{question}</h3>
          </summary>
          <p className={styles.answer}>{answer}</p>
        </details>
      ))}
    </section>
  );
};

export default ArticleFaq;
